import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5f1ac2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "arcode-status-bar" }
const _hoisted_2 = { key: 0 }

import { computed } from 'vue';
import Workspace from '@/components/composed/Workspace.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusBar',
  props: {
	workspace: Object
},
  setup(__props) {

const props = __props;



const getEditorsFilename = (editorId: number, workspace: Workspace): string => {
	const i = workspace.editors.findIndex(ed => ed.id == editorId);
	let name = '';
	if (workspace && workspace.editors && workspace.editors[i] &&
			workspace.editors[i].name) {
		name = workspace.editors[i].name;
	}
	return name;
};

const statusBarText = computed(() => {
	const workspace = props.workspace;
	const content = workspace.getCurrentContent();
	const fname = getEditorsFilename(workspace.getCurrentEditorId(), workspace);
	const numChar = content.length;
	const numLines = content.match(/\n/g) ?
		content.match(/\n/g).length + 1 :
		1;
  const numBytes = new Blob([content]).size;
  const pluralLines = numLines != 1 ? 's' : '';
  const pluralBytes = numBytes != 1 ? 's' : '';
  const pluralCharacters = numChar != 1 ? 's' : '';
	const s = `Current file: ${fname} | ${numChar} character${pluralCharacters} | ${numBytes} byte${pluralBytes} | ${numLines} line${pluralLines}`;
	return s;
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.workspace && __props.workspace.getCurrentEditorId() >= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(statusBarText)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})